<template>
  <!--  begin intro section -->
  <section class="intro bg-light-gray">
    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <img
            src="assets/img/intro.jpg"
            class="img-responsive center-block"
            alt="intro"
          />
        </div>

        <div class="col-md-7">
          <div class="intro-description">
            <h2>We transform ideas into digital solutions</h2>
            <p>
              At DIGIPROD, we combine cutting-edge technology and creativity to
              deliver tailor-made solutions in development, infrastructure, and
              digital marketing. Our mission is to make technology accessible,
              scalable, and aligned with real business needs.
            </p>

            <ul class="points">
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Custom development focused on performance and scalability.
              </li>
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Modern cloud infrastructure with automation and security.
              </li>
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Design, branding, and digital marketing to position your brand.
              </li>
              <li>
                <span>
                  <i class="fa fa-star"></i>
                </span>
                Close, agile service focused on customer success.
              </li>
            </ul>
            <!-- end of /.points -->

            <!-- <a href="#" class="btn btn-slategray"> purchase </a> -->
            <!-- /purchase button -->
          </div>
          <!-- end of /.intro-description -->
        </div>
      </div>
    </div>
    <!-- end of /.container -->
  </section>
  <!--  end of intro section -->
</template>

<script>
export default {
  name: "IntroSection",
};
</script>
